<form [formGroup]="_newPasswordForm" (ngSubmit)="setNewPassword(activate)">
  <input type="password" formControlName="password1" name="password1" placeholder="Nuova password">
  <app-error-html-handler [ctrl]="_newPasswordForm.get('password1')" [messages]="formValidationMsgs.password1">
  </app-error-html-handler>
  <input type="password" formControlName="password2" name="password2" placeholder="Ripeti password">
  <app-error-html-handler [ctrl]="_newPasswordForm.get('password2')" [messages]="formValidationMsgs.password2">
  </app-error-html-handler>
</form>
